// document.addEventListener('DOMContentLoaded', function () {
//   const trigger = document.getElementById('CustomizePackTrigger');
//   const modal = document.getElementById('CustomizePackModal');
//   const closeButton = document.getElementById('CustomizePackClose');
//   const overlay = modal
//     ? modal.querySelector('.customize-pack-overlay')
//     : null;

//   const flavorRow3 = document.getElementById('CustomFlavorRow3');
//   const addToCartButton = document.getElementById('CustomPackAddToCart');
//   const errorMessage = document.getElementById('CustomPackError');

//   const packSizeInputs = document.querySelectorAll(
//     'input[name="custom_pack_size"]'
//   );

//   if (!trigger || !modal) {
//     return;
//   }

//   /*
//    * Flavor Variant Mapping
//    *
//    * 2 = 2 Packs
//    * 3 = 3 Packs
//    */

//   const flavorVariants = {
//     berry: {
//       2: '52068743446803',
//       3: '52068742070547'
//     },

//     sweetPotato: {
//       2: '52124354511123',
//       3: '52124354543891'
//     },

//     southernOriginal: {
//       2: '52124358017299',
//       3: '52124358050067'
//     }
//   };


//   /*
//    * Open Customize Pack Modal
//    */

//   trigger.addEventListener('click', function () {
//     modal.hidden = false;
//     document.body.classList.add('customize-pack-open');
//   });


//   /*
//    * Close Customize Pack Modal
//    */

//   function closeModal() {
//     modal.hidden = true;
//     document.body.classList.remove('customize-pack-open');
//   }

//   if (closeButton) {
//     closeButton.addEventListener('click', closeModal);
//   }

//   if (overlay) {
//     overlay.addEventListener('click', closeModal);
//   }


//   /*
//    * Escape key closes modal
//    */

//   document.addEventListener('keydown', function (event) {
//     if (event.key === 'Escape' && !modal.hidden) {
//       closeModal();
//     }
//   });


//   /*
//    * Show Error
//    */

//   function showError(message) {
//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent = message;
//     errorMessage.hidden = false;
//   }


//   /*
//    * Hide Error
//    */

//   function hideError() {
//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent = '';
//     errorMessage.hidden = true;
//   }


//   /*
//    * Pack Size Selection
//    */

//   packSizeInputs.forEach(function (input) {
//     input.addEventListener('change', function () {

//       document
//         .querySelectorAll('.custom-pack-size-option')
//         .forEach(function (option) {
//           option.classList.remove('active');
//         });

//       const parent = input.closest('.custom-pack-size-option');

//       if (parent) {
//         parent.classList.add('active');
//       }

//       if (input.value === '3') {

//         if (flavorRow3) {
//           flavorRow3.hidden = false;
//         }

//       } else {

//         if (flavorRow3) {
//           flavorRow3.hidden = true;
//         }

//         const flavor3 =
//           document.getElementById('custom-flavor-3');

//         if (flavor3) {
//           flavor3.value = '';
//         }
//       }

//     });
//   });


//   /*
//    * Refresh Cart Drawer + Cart Icon
//    */

//   async function refreshCartUI() {

//     try {

//       /*
//        * Get current cart
//        */

//       const cartResponse = await fetch(
//         window.Shopify.routes.root + 'cart.js',
//         {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json'
//           }
//         }
//       );

//       if (!cartResponse.ok) {
//         throw new Error('Unable to get cart.');
//       }

//       const cart = await cartResponse.json();


//       /*
//        * Update cart count manually
//        */

//       document
//         .querySelectorAll(
//           '.cart-count-bubble, .cart-count, [data-cart-count]'
//         )
//         .forEach(function (element) {

//           /*
//            * If element itself contains the number
//            */

//           if (
//             element.matches(
//               '.cart-count, [data-cart-count]'
//             )
//           ) {

//             element.textContent =
//               cart.item_count;

//           }

//           /*
//            * Dawn cart count bubble
//            */

//           const countSpan =
//             element.querySelector('span');

//           if (countSpan) {

//             countSpan.textContent =
//               cart.item_count;

//           }

//         });


//       /*
//        * Get fresh cart drawer HTML
//        *
//        * Shopify section rendering
//        */

//       const sectionsUrl =
//         window.location.pathname +
//         '?sections=cart-drawer,cart-icon-bubble';


//       const sectionsResponse = await fetch(
//         sectionsUrl,
//         {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json'
//           }
//         }
//       );


//       if (sectionsResponse.ok) {

//         const sections =
//           await sectionsResponse.json();


//         /*
//          * Update Cart Drawer
//          */

//         if (sections['cart-drawer']) {

//           const parser =
//             new DOMParser();

//           const drawerDocument =
//             parser.parseFromString(
//               sections['cart-drawer'],
//               'text/html'
//             );

//           const newCartDrawer =
//             drawerDocument.querySelector(
//               'cart-drawer'
//             );

//           const currentCartDrawer =
//             document.querySelector(
//               'cart-drawer'
//             );


//           if (
//             newCartDrawer &&
//             currentCartDrawer
//           ) {

//             /*
//              * Replace entire cart drawer
//              */

//             currentCartDrawer.replaceWith(
//               newCartDrawer
//             );

//           }

//         }


//         /*
//          * Update Cart Icon Bubble
//          */

//         if (sections['cart-icon-bubble']) {

//           const parser =
//             new DOMParser();

//           const iconDocument =
//             parser.parseFromString(
//               sections['cart-icon-bubble'],
//               'text/html'
//             );


//           const newCartIcon =
//             iconDocument.querySelector(
//               '#cart-icon-bubble'
//             );


//           const currentCartIcon =
//             document.querySelector(
//               '#cart-icon-bubble'
//             );


//           if (
//             newCartIcon &&
//             currentCartIcon
//           ) {

//             currentCartIcon.replaceWith(
//               newCartIcon
//             );

//           }

//         }

//       }


//       /*
//        * Shopify / Theme cart events
//        */

//       document.dispatchEvent(
//         new CustomEvent(
//           'cart:updated',
//           {
//             bubbles: true,
//             detail: {
//               cart: cart
//             }
//           }
//         )
//       );


//       document.documentElement.dispatchEvent(
//         new CustomEvent(
//           'cart:refresh',
//           {
//             bubbles: true,
//             detail: {
//               cart: cart
//             }
//           }
//         )
//       );


//       /*
//        * Re-check cart drawer after replacement
//        */

//       const updatedDrawer =
//         document.querySelector(
//           'cart-drawer'
//         );


//       /*
//        * Open cart drawer
//        */

//       if (
//         updatedDrawer &&
//         typeof updatedDrawer.open === 'function'
//       ) {

//         updatedDrawer.open();

//       }


//       /*
//        * Also try common Dawn cart drawer methods
//        */

//       if (
//         updatedDrawer &&
//         typeof updatedDrawer.renderContents === 'function'
//       ) {

//         /*
//          * renderContents requires sections from
//          * Shopify's add.js response, so we don't
//          * call it here.
//          */

//       }

//       return cart;

//     } catch (error) {

//       console.error(
//         'Cart UI refresh error:',
//         error
//       );

//       return null;
//     }

//   }


//   /*
//    * Add Customized Pack
//    */

//   if (addToCartButton) {

//     addToCartButton.addEventListener(
//       'click',
//       async function () {

//         hideError();


//         /*
//          * Get selected pack size
//          */

//         const selectedPackInput =
//           document.querySelector(
//             'input[name="custom_pack_size"]:checked'
//           );


//         if (!selectedPackInput) {

//           showError(
//             'Please select a pack size.'
//           );

//           return;
//         }


//         const packSize =
//           selectedPackInput.value;


//         /*
//          * Get selected flavors
//          */

//         const flavor1 =
//           document.getElementById(
//             'custom-flavor-1'
//           )?.value || '';


//         const flavor2 =
//           document.getElementById(
//             'custom-flavor-2'
//           )?.value || '';


//         const flavor3 =
//           document.getElementById(
//             'custom-flavor-3'
//           )?.value || '';


//         /*
//          * Validate first 2 flavors
//          */

//         if (!flavor1 || !flavor2) {

//           showError(
//             'Please select both flavors.'
//           );

//           return;
//         }


//         /*
//          * Validate third flavor
//          */

//         if (
//           packSize === '3' &&
//           !flavor3
//         ) {

//           showError(
//             'Please select all 3 flavors.'
//           );

//           return;
//         }


//         /*
//          * Selected flavors
//          */

//         const selectedFlavors = [
//           flavor1,
//           flavor2
//         ];


//         if (packSize === '3') {

//           selectedFlavors.push(
//             flavor3
//           );

//         }


//         /*
//          * Convert selected flavor
//          * to variant ID
//          */

//         const items = [];


//         selectedFlavors.forEach(
//           function (flavor) {

//             let variantId = null;


//             /*
//              * Berry
//              */

//             if (
//               flavor === 'berry' ||
//               flavor === 'berry-cinnamon-roll'
//             ) {

//               variantId =
//                 flavorVariants.berry[packSize];

//             }


//             /*
//              * Sweet Potato
//              */

//             if (
//               flavor === 'sweet-potato' ||
//               flavor === 'sweet-potato-roll'
//             ) {

//               variantId =
//                 flavorVariants.sweetPotato[packSize];

//             }


//             /*
//              * Southern Original
//              */

//             if (
//               flavor === 'southern-original' ||
//               flavor === 'southern-original-roll'
//             ) {

//               variantId =
//                 flavorVariants.southernOriginal[packSize];

//             }


//             /*
//              * Add item
//              */

//             if (variantId) {

//               items.push({
//                 id: Number(variantId),
//                 quantity: 1
//               });

//             }

//           }
//         );


//         /*
//          * Validate variants
//          */

//         if (
//           items.length !==
//           selectedFlavors.length
//         ) {

//           console.log(
//             'Selected flavors:',
//             selectedFlavors
//           );

//           console.log(
//             'Generated items:',
//             items
//           );

//           showError(
//             'One of the selected flavors could not be added. Please try again.'
//           );

//           return;
//         }


//         /*
//          * Disable button
//          */

//         const originalButtonText =
//           addToCartButton.textContent;

//         addToCartButton.disabled = true;

//         addToCartButton.textContent =
//           'Adding...';


//         try {

//           /*
//            * Add multiple variants
//            */

//           const response =
//             await fetch(
//               window.Shopify.routes.root +
//               'cart/add.js',
//               {
//                 method: 'POST',

//                 headers: {
//                   'Content-Type':
//                     'application/json',

//                   'Accept':
//                     'application/json'
//                 },

//                 body: JSON.stringify({
//                   items: items
//                 })
//               }
//             );


//           /*
//            * Get response
//            */

//           const data =
//             await response.json();


//           /*
//            * Shopify error
//            */

//           if (!response.ok) {

//             console.error(
//               'Shopify cart error:',
//               data
//             );

//             throw new Error(
//               data.description ||
//               data.message ||
//               'Unable to add customized pack.'
//             );

//           }


//           console.log(
//             'Customized pack added:',
//             data
//           );


//           /*
//            * Refresh cart UI
//            */

//           await refreshCartUI();


//           /*
//            * Close customize modal
//            */

//           closeModal();


//         } catch (error) {

//           console.error(
//             'Customized pack error:',
//             error
//           );


//           showError(
//             error.message ||
//             'Something went wrong. Please try again.'
//           );


//         } finally {

//           /*
//            * Enable button again
//            */

//           addToCartButton.disabled =
//             false;

//           addToCartButton.textContent =
//             originalButtonText;

//         }

//       }
//     );

//   }

// });


// new wroking js


// document.addEventListener('DOMContentLoaded', function () {

//   /*
//    * =========================================================
//    * ELEMENTS
//    * =========================================================
//    */

//   const trigger =
//     document.getElementById('CustomizePackTrigger');

//   const modal =
//     document.getElementById('CustomizePackModal');

//   const closeButton =
//     document.getElementById('CustomizePackClose');

//   const overlay =
//     modal
//       ? modal.querySelector('.customize-pack-overlay')
//       : null;

//   const flavorRow3 =
//     document.getElementById('CustomFlavorRow3');

//   const addButton =
//     document.getElementById('CustomPackAddToCart');

//   const errorMessage =
//     document.getElementById('CustomPackError');

//   const packSizeInputs =
//     document.querySelectorAll(
//       'input[name="custom_pack_size"]'
//     );


//   /*
//    * =========================================================
//    * CHECK REQUIRED ELEMENTS
//    * =========================================================
//    */

//   if (!trigger || !modal || !addButton) {

//     console.log(
//       'Customize Pack: Required elements not found.'
//     );

//     return;
//   }


//   /*
//    * =========================================================
//    * FLAVOR VARIANT IDs
//    * =========================================================
//    *
//    * 2 = 2 Packs
//    * 3 = 3 Packs
//    */

//   const flavorVariants = {

//     berry: {
//       2: 52068743446803,
//       3: 52068742070547
//     },

//     sweetPotato: {
//       2: 52124354511123,
//       3: 52124354543891
//     },

//     southernOriginal: {
//       2: 52124358017299,
//       3: 52124358050067
//     }

//   };


//   /*
//    * =========================================================
//    * OPEN MODAL
//    * =========================================================
//    */

//   trigger.addEventListener(
//     'click',
//     function () {

//       modal.hidden = false;

//       document.body.classList.add(
//         'customize-pack-open'
//       );

//     }
//   );


//   /*
//    * =========================================================
//    * CLOSE MODAL
//    * =========================================================
//    */

//   function closeModal() {

//     modal.hidden = true;

//     document.body.classList.remove(
//       'customize-pack-open'
//     );

//   }


//   if (closeButton) {

//     closeButton.addEventListener(
//       'click',
//       closeModal
//     );

//   }


//   if (overlay) {

//     overlay.addEventListener(
//       'click',
//       closeModal
//     );

//   }


//   /*
//    * =========================================================
//    * ESCAPE KEY
//    * =========================================================
//    */

//   document.addEventListener(
//     'keydown',
//     function (event) {

//       if (
//         event.key === 'Escape' &&
//         !modal.hidden
//       ) {

//         closeModal();

//       }

//     }
//   );


//   /*
//    * =========================================================
//    * ERROR FUNCTIONS
//    * =========================================================
//    */

//   function showError(message) {

//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent =
//       message;

//     errorMessage.hidden = false;

//   }


//   function hideError() {

//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent = '';

//     errorMessage.hidden = true;

//   }


//   /*
//    * =========================================================
//    * PACK SIZE SELECTION
//    * =========================================================
//    *
//    * IMPORTANT:
//    *
//    * 2 Packs -> 3 flavor selectors
//    * 3 Packs -> 3 flavor selectors
//    *
//    * Third flavor is ALWAYS visible.
//    */

//   packSizeInputs.forEach(
//     function (input) {

//       input.addEventListener(
//         'change',
//         function () {

//           /*
//            * Remove active class
//            */

//           document
//             .querySelectorAll(
//               '.custom-pack-size-option'
//             )
//             .forEach(
//               function (option) {

//                 option.classList.remove(
//                   'active'
//                 );

//               }
//             );


//           /*
//            * Add active class
//            */

//           const parent =
//             input.closest(
//               '.custom-pack-size-option'
//             );


//           if (parent) {

//             parent.classList.add(
//               'active'
//             );

//           }


//           /*
//            * ALWAYS SHOW THIRD FLAVOR
//            */

//           if (flavorRow3) {

//             flavorRow3.hidden = false;

//           }

//         }
//       );

//     }
//   );


//   /*
//    * =========================================================
//    * INITIAL THIRD FLAVOR VISIBILITY
//    * =========================================================
//    */

//   if (flavorRow3) {

//     flavorRow3.hidden = false;

//   }


//   /*
//    * =========================================================
//    * GET VARIANT ID
//    * =========================================================
//    */

//   function getVariantId(
//     flavor,
//     packSize
//   ) {

//     /*
//      * -----------------------------
//      * BERRY
//      * -----------------------------
//      */

//     if (
//       flavor === 'berry' ||
//       flavor === 'berry-cinnamon-roll' ||
//       flavor === 'berry-cinnamon'
//     ) {

//       return flavorVariants
//         .berry[packSize];

//     }


//     /*
//      * -----------------------------
//      * SWEET POTATO
//      * -----------------------------
//      */

//     if (
//       flavor === 'sweet-potato' ||
//       flavor === 'sweet-potato-roll' ||
//       flavor === 'sweet_potato'
//     ) {

//       return flavorVariants
//         .sweetPotato[packSize];

//     }


//     /*
//      * -----------------------------
//      * SOUTHERN ORIGINAL
//      * -----------------------------
//      */

//     if (
//       flavor === 'southern-original' ||
//       flavor === 'southern-original-roll' ||
//       flavor === 'southern_original'
//     ) {

//       return flavorVariants
//         .southernOriginal[packSize];

//     }


//     /*
//      * Unknown flavor
//      */

//     return null;

//   }


//   /*
//    * =========================================================
//    * GET SELECTED FLAVORS
//    * =========================================================
//    */

//   function getSelectedFlavors() {

//     const flavor1 =
//       document.getElementById(
//         'custom-flavor-1'
//       )?.value || '';


//     const flavor2 =
//       document.getElementById(
//         'custom-flavor-2'
//       )?.value || '';


//     const flavor3 =
//       document.getElementById(
//         'custom-flavor-3'
//       )?.value || '';


//     return [
//       flavor1,
//       flavor2,
//       flavor3
//     ];

//   }


//   /*
//    * =========================================================
//    * UPDATE CART DRAWER
//    * =========================================================
//    */

//   function updateCartDrawer(data) {

//     const cartDrawer =
//       document.querySelector(
//         'cart-drawer'
//       );


//     /*
//      * -------------------------------------------------------
//      * USE NATIVE CART DRAWER
//      * -------------------------------------------------------
//      */

//     if (
//       cartDrawer &&
//       typeof cartDrawer.renderContents ===
//         'function'
//     ) {

//       try {

//         cartDrawer.renderContents(
//           data
//         );

//         console.log(
//           'Cart drawer updated using renderContents().'
//         );

//         return true;

//       } catch (error) {

//         console.error(
//           'CartDrawer renderContents error:',
//           error
//         );

//       }

//     }


//     /*
//      * -------------------------------------------------------
//      * FALLBACK: UPDATE CART ICON
//      * -------------------------------------------------------
//      */

//     if (
//       data.sections &&
//       data.sections[
//         'cart-icon-bubble'
//       ]
//     ) {

//       try {

//         const parser =
//           new DOMParser();


//         const html =
//           parser.parseFromString(
//             data.sections[
//               'cart-icon-bubble'
//             ],
//             'text/html'
//           );


//         const newCartIcon =
//           html.querySelector(
//             '#cart-icon-bubble'
//           );


//         const currentCartIcon =
//           document.querySelector(
//             '#cart-icon-bubble'
//           );


//         if (
//           newCartIcon &&
//           currentCartIcon
//         ) {

//           currentCartIcon.replaceWith(
//             newCartIcon
//           );

//           console.log(
//             'Cart icon updated using fallback.'
//           );

//           return true;

//         }

//       } catch (error) {

//         console.error(
//           'Cart icon update error:',
//           error
//         );

//       }

//     }


//     return false;

//   }


//   /*
//    * =========================================================
//    * ADD CUSTOM PACK
//    * =========================================================
//    */

//   addButton.addEventListener(
//     'click',
//     async function () {

//       hideError();


//       /*
//        * -------------------------------------------------------
//        * GET PACK SIZE
//        * -------------------------------------------------------
//        */

//       const selectedPack =
//         document.querySelector(
//           'input[name="custom_pack_size"]:checked'
//         );


//       if (!selectedPack) {

//         showError(
//           'Please select a pack size.'
//         );

//         return;

//       }


//       const packSize =
//         selectedPack.value;


//       /*
//        * -------------------------------------------------------
//        * GET ALL 3 FLAVORS
//        * -------------------------------------------------------
//        */

//       const flavors =
//         getSelectedFlavors();


//       console.log(
//         'Selected Pack:',
//         packSize
//       );


//       console.log(
//         'All Flavor Selections:',
//         flavors
//       );


//       /*
//        * -------------------------------------------------------
//        * REMOVE EMPTY FLAVORS
//        * -------------------------------------------------------
//        *
//        * Customer can select:
//        *
//        * 2 flavors ✅
//        * 3 flavors ✅
//        *
//        * But cannot select only 1.
//        */

//       const selectedFlavors =
//         flavors.filter(
//           function (flavor) {

//             return (
//               flavor &&
//               flavor.trim() !== ''
//             );

//           }
//         );


//       console.log(
//         'Selected Flavors:',
//         selectedFlavors
//       );


//       /*
//        * -------------------------------------------------------
//        * MINIMUM 2 FLAVORS
//        * -------------------------------------------------------
//        */

//       if (
//         selectedFlavors.length < 2
//       ) {

//         showError(
//           'Please select at least 2 flavors.'
//         );

//         return;

//       }


//       /*
//        * -------------------------------------------------------
//        * BUILD CART ITEMS
//        * -------------------------------------------------------
//        *
//        * 2 Packs + 2 flavors:
//        *
//        * Berry 2 Pack
//        * Sweet Potato 2 Pack
//        *
//        *
//        * 2 Packs + 3 flavors:
//        *
//        * Berry 2 Pack
//        * Sweet Potato 2 Pack
//        * Southern Original 2 Pack
//        *
//        *
//        * 3 Packs + 2 flavors:
//        *
//        * Berry 3 Pack
//        * Sweet Potato 3 Pack
//        *
//        *
//        * 3 Packs + 3 flavors:
//        *
//        * Berry 3 Pack
//        * Sweet Potato 3 Pack
//        * Southern Original 3 Pack
//        */

//       const items = [];


//       selectedFlavors.forEach(
//         function (flavor) {

//           const variantId =
//             getVariantId(
//               flavor,
//               packSize
//             );


//           console.log(
//             'Flavor:',
//             flavor,
//             'Pack:',
//             packSize,
//             'Variant:',
//             variantId
//           );


//           if (variantId) {

//             items.push({

//               id: Number(variantId),

//               quantity: 1

//             });

//           }

//         }
//       );


//       /*
//        * -------------------------------------------------------
//        * VALIDATE CART ITEMS
//        * -------------------------------------------------------
//        */

//       if (
//         items.length !==
//         selectedFlavors.length
//       ) {

//         console.error(
//           'Unable to create all cart items.',
//           {
//             flavors:
//               selectedFlavors,

//             items:
//               items
//           }
//         );


//         showError(
//           'One or more selected flavors could not be found.'
//         );

//         return;

//       }


//       /*
//        * -------------------------------------------------------
//        * BUTTON LOADING
//        * -------------------------------------------------------
//        */

//       const originalText =
//         addButton.textContent;


//       addButton.disabled =
//         true;


//       addButton.textContent =
//         'Adding...';


//       try {


//         /*
//          * =====================================================
//          * ADD PRODUCTS TO SHOPIFY CART
//          * =====================================================
//          */

//         const response =
//           await fetch(
//             window.Shopify.routes.root +
//             'cart/add.js',
//             {

//               method: 'POST',

//               headers: {

//                 'Content-Type':
//                   'application/json',

//                 'Accept':
//                   'application/json'

//               },

//               body: JSON.stringify({

//                 items: items,

//                 /*
//                  * Request fresh cart sections.
//                  */

//                 sections: [
//                   'cart-drawer',
//                   'cart-icon-bubble'
//                 ],

//                 sections_url:
//                   window.location.pathname

//               })

//             }
//           );


//         /*
//          * Parse response
//          */

//         const data =
//           await response.json();


//         console.log(
//           'Shopify Cart Response:',
//           data
//         );


//         /*
//          * -------------------------------------------------------
//          * CHECK SHOPIFY ERROR
//          * -------------------------------------------------------
//          */

//         if (!response.ok) {

//           throw new Error(
//             data.description ||
//             data.message ||
//             'Unable to add customized pack.'
//           );

//         }


//         /*
//          * -------------------------------------------------------
//          * CHECK SECTIONS
//          * -------------------------------------------------------
//          */

//         if (!data.sections) {

//           console.warn(
//             'Shopify did not return cart sections.'
//           );

//         }


//         /*
//          * =====================================================
//          * UPDATE CART DRAWER + HEADER CART
//          * =====================================================
//          */

//         updateCartDrawer(
//           data
//         );


//         /*
//          * =====================================================
//          * CLOSE CUSTOMIZATION MODAL
//          * =====================================================
//          */

//         closeModal();


//         /*
//          * =====================================================
//          * FALLBACK OPEN CART DRAWER
//          * =====================================================
//          */

//         setTimeout(
//           function () {

//             const cartDrawer =
//               document.querySelector(
//                 'cart-drawer'
//               );


//             if (
//               cartDrawer &&
//               !cartDrawer.classList.contains(
//                 'active'
//               ) &&
//               typeof cartDrawer.open ===
//                 'function'
//             ) {

//               cartDrawer.open();

//             }

//           },
//           100
//         );


//       } catch (error) {

//         console.error(
//           'CUSTOM PACK ERROR:',
//           error
//         );


//         showError(
//           error.message ||
//           'Something went wrong. Please try again.'
//         );


//       } finally {


//         /*
//          * -------------------------------------------------------
//          * RESTORE BUTTON
//          * -------------------------------------------------------
//          */

//         addButton.disabled =
//           false;


//         addButton.textContent =
//           originalText;

//       }

//     }
//   );

// });


// document.addEventListener('DOMContentLoaded', function () {

//   /*
//    * =========================================================
//    * ELEMENTS
//    * =========================================================
//    */

//   const trigger =
//     document.getElementById('CustomizePackTrigger');

//   const modal =
//     document.getElementById('CustomizePackModal');

//   const closeButton =
//     document.getElementById('CustomizePackClose');

//   const overlay =
//     modal
//       ? modal.querySelector('.customize-pack-overlay')
//       : null;

//   const flavorRow3 =
//     document.getElementById('CustomFlavorRow3');

//   const addButton =
//     document.getElementById('CustomPackAddToCart');

//   const errorMessage =
//     document.getElementById('CustomPackError');

//   const packSizeInputs =
//     document.querySelectorAll(
//       'input[name="custom_pack_size"]'
//     );


//   /*
//    * =========================================================
//    * CHECK REQUIRED ELEMENTS
//    * =========================================================
//    */

//   if (!trigger || !modal || !addButton) {

//     console.log(
//       'Customize Pack: Required elements not found.'
//     );

//     return;
//   }


//   /*
//    * =========================================================
//    * FLAVOR VARIANT IDs
//    * =========================================================
//    *
//    * 2 = 2 Packs
//    * 3 = 3 Packs
//    */

//   const flavorVariants = {

//     berry: {
//       2: 52068743446803,
//       3: 52068742070547
//     },

//     sweetPotato: {
//       2: 52124354511123,
//       3: 52124354543891
//     },

//     southernOriginal: {
//       2: 52124358017299,
//       3: 52124358050067
//     }

//   };


//   /*
//    * =========================================================
//    * GENERATE UNIQUE CUSTOM PACK ID
//    * =========================================================
//    */

//   function generateCustomPackId() {

//     const timestamp =
//       Date.now();

//     const random =
//       Math.random()
//         .toString(36)
//         .substring(2, 7);

//     return (
//       'CP-' +
//       timestamp +
//       '-' +
//       random
//     );

//   }


//   /*
//    * =========================================================
//    * OPEN MODAL
//    * =========================================================
//    */

//   trigger.addEventListener(
//     'click',
//     function () {

//       modal.hidden = false;

//       document.body.classList.add(
//         'customize-pack-open'
//       );

//       /*
//        * Refresh flavor availability
//        */
//       updateFlavorOptions();

//     }
//   );


//   /*
//    * =========================================================
//    * CLOSE MODAL
//    * =========================================================
//    */

//   function closeModal() {

//     modal.hidden = true;

//     document.body.classList.remove(
//       'customize-pack-open'
//     );

//   }


//   if (closeButton) {

//     closeButton.addEventListener(
//       'click',
//       closeModal
//     );

//   }


//   if (overlay) {

//     overlay.addEventListener(
//       'click',
//       closeModal
//     );

//   }


//   /*
//    * =========================================================
//    * ESCAPE KEY
//    * =========================================================
//    */

//   document.addEventListener(
//     'keydown',
//     function (event) {

//       if (
//         event.key === 'Escape' &&
//         !modal.hidden
//       ) {

//         closeModal();

//       }

//     }
//   );


//   /*
//    * =========================================================
//    * ERROR FUNCTIONS
//    * =========================================================
//    */

//   function showError(message) {

//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent =
//       message;

//     errorMessage.hidden = false;

//   }


//   function hideError() {

//     if (!errorMessage) {
//       return;
//     }

//     errorMessage.textContent = '';

//     errorMessage.hidden = true;

//   }


//   /*
//    * =========================================================
//    * FLAVOR SELECT ELEMENTS
//    * =========================================================
//    */

//   function getFlavorSelects() {

//     return [
//       document.getElementById('custom-flavor-1'),
//       document.getElementById('custom-flavor-2'),
//       document.getElementById('custom-flavor-3')
//     ];

//   }


//   /*
//    * =========================================================
//    * PREVENT DUPLICATE FLAVORS
//    * =========================================================
//    *
//    * Example:
//    *
//    * Flavor 1 = Berry
//    *
//    * Flavor 2:
//    * Berry             -> DISABLED
//    * Sweet Potato      -> AVAILABLE
//    * Southern Original -> AVAILABLE
//    *
//    * If Flavor 2 = Sweet Potato:
//    *
//    * Flavor 3:
//    * Berry             -> DISABLED
//    * Sweet Potato      -> DISABLED
//    * Southern Original -> AVAILABLE
//    */

//   function updateFlavorOptions() {

//     const flavorSelects =
//       getFlavorSelects();


//     /*
//      * Get all selected flavors
//      */

//     const selectedValues =
//       flavorSelects
//         .map(function (select) {

//           return select
//             ? select.value
//             : '';

//         })
//         .filter(function (value) {

//           return (
//             value &&
//             value.trim() !== ''
//           );

//         });


//     /*
//      * Update every select
//      */

//     flavorSelects.forEach(
//       function (select) {

//         if (!select) {
//           return;
//         }


//         /*
//          * Current selected value
//          *
//          * We don't disable the current
//          * selected option in its own select.
//          */

//         const currentValue =
//           select.value;


//         /*
//          * Loop through options
//          */

//         Array.from(
//           select.options
//         ).forEach(
//           function (option) {

//             /*
//              * Placeholder
//              */

//             if (!option.value) {

//               option.disabled =
//                 false;

//               return;

//             }


//             /*
//              * Check if this flavor
//              * is selected in another
//              * selector.
//              */

//             const usedInAnotherSelector =
//               selectedValues.includes(
//                 option.value
//               ) &&
//               option.value !==
//                 currentValue;


//             /*
//              * Disable duplicate
//              */

//             option.disabled =
//               usedInAnotherSelector;

//           }
//         );

//       }
//     );

//   }


//   /*
//    * =========================================================
//    * FLAVOR CHANGE EVENTS
//    * =========================================================
//    */

//   function attachFlavorChangeEvents() {

//     const flavorSelects =
//       getFlavorSelects();


//     flavorSelects.forEach(
//       function (select) {

//         if (!select) {
//           return;
//         }


//         /*
//          * Prevent duplicate event listeners
//          */

//         if (
//           select.dataset.customPackListener ===
//           'true'
//         ) {

//           return;

//         }


//         select.dataset.customPackListener =
//           'true';


//         select.addEventListener(
//           'change',
//           function () {

//             /*
//              * Clear previous error
//              */

//             hideError();


//             /*
//              * Update duplicate options
//              */

//             updateFlavorOptions();

//           }
//         );

//       }
//     );

//   }


//   /*
//    * =========================================================
//    * INITIALIZE FLAVOR OPTIONS
//    * =========================================================
//    */

//   attachFlavorChangeEvents();

//   updateFlavorOptions();


//   /*
//    * =========================================================
//    * PACK SIZE SELECTION
//    * =========================================================
//    *
//    * Both 2 Packs and 3 Packs have
//    * 3 flavor selectors.
//    */

//   packSizeInputs.forEach(
//     function (input) {

//       input.addEventListener(
//         'change',
//         function () {

//           /*
//            * Remove active class
//            */

//           document
//             .querySelectorAll(
//               '.custom-pack-size-option'
//             )
//             .forEach(
//               function (option) {

//                 option.classList.remove(
//                   'active'
//                 );

//               }
//             );


//           /*
//            * Add active class
//            */

//           const parent =
//             input.closest(
//               '.custom-pack-size-option'
//             );


//           if (parent) {

//             parent.classList.add(
//               'active'
//             );

//           }


//           /*
//            * Always show third flavor
//            */

//           if (flavorRow3) {

//             flavorRow3.hidden =
//               false;

//           }


//           /*
//            * Refresh duplicate prevention
//            */

//           updateFlavorOptions();

//         }
//       );

//     }
//   );


//   /*
//    * =========================================================
//    * INITIAL THIRD FLAVOR VISIBILITY
//    * =========================================================
//    */

//   if (flavorRow3) {

//     flavorRow3.hidden =
//       false;

//   }


//   /*
//    * =========================================================
//    * GET VARIANT ID
//    * =========================================================
//    */

//   function getVariantId(
//     flavor,
//     packSize
//   ) {

//     /*
//      * -----------------------------
//      * BERRY
//      * -----------------------------
//      */

//     if (
//       flavor === 'berry' ||
//       flavor === 'berry-cinnamon-roll' ||
//       flavor === 'berry-cinnamon'
//     ) {

//       return flavorVariants
//         .berry[packSize];

//     }


//     /*
//      * -----------------------------
//      * SWEET POTATO
//      * -----------------------------
//      */

//     if (
//       flavor === 'sweet-potato' ||
//       flavor === 'sweet-potato-roll' ||
//       flavor === 'sweet_potato'
//     ) {

//       return flavorVariants
//         .sweetPotato[packSize];

//     }


//     /*
//      * -----------------------------
//      * SOUTHERN ORIGINAL
//      * -----------------------------
//      */

//     if (
//       flavor === 'southern-original' ||
//       flavor === 'southern-original-roll' ||
//       flavor === 'southern_original'
//     ) {

//       return flavorVariants
//         .southernOriginal[packSize];

//     }


//     /*
//      * Unknown flavor
//      */

//     return null;

//   }


//   /*
//    * =========================================================
//    * GET SELECTED FLAVORS
//    * =========================================================
//    */

//   function getSelectedFlavors() {

//     const flavor1 =
//       document.getElementById(
//         'custom-flavor-1'
//       )?.value || '';


//     const flavor2 =
//       document.getElementById(
//         'custom-flavor-2'
//       )?.value || '';


//     const flavor3 =
//       document.getElementById(
//         'custom-flavor-3'
//       )?.value || '';


//     return [
//       flavor1,
//       flavor2,
//       flavor3
//     ];

//   }


//   /*
//    * =========================================================
//    * VALIDATE UNIQUE FLAVORS
//    * =========================================================
//    *
//    * Extra safety check before adding
//    * products to cart.
//    *
//    * Even if duplicate options somehow
//    * become selectable, we stop them here.
//    */

//   function hasDuplicateFlavors(
//     selectedFlavors
//   ) {

//     const uniqueFlavors =
//       new Set(
//         selectedFlavors
//       );

//     return (
//       uniqueFlavors.size !==
//       selectedFlavors.length
//     );

//   }


//   /*
//    * =========================================================
//    * UPDATE CART DRAWER
//    * =========================================================
//    */

//   function updateCartDrawer(data) {

//     const cartDrawer =
//       document.querySelector(
//         'cart-drawer'
//       );


//     /*
//      * -------------------------------------------------------
//      * USE NATIVE DAWN CART DRAWER
//      * -------------------------------------------------------
//      */

//     if (
//       cartDrawer &&
//       typeof cartDrawer.renderContents ===
//         'function'
//     ) {

//       try {

//         cartDrawer.renderContents(
//           data
//         );

//         console.log(
//           'Cart drawer updated using renderContents().'
//         );

//         return true;

//       } catch (error) {

//         console.error(
//           'CartDrawer renderContents error:',
//           error
//         );

//       }

//     }


//     /*
//      * -------------------------------------------------------
//      * FALLBACK: UPDATE CART ICON
//      * -------------------------------------------------------
//      */

//     if (
//       data.sections &&
//       data.sections[
//         'cart-icon-bubble'
//       ]
//     ) {

//       try {

//         const parser =
//           new DOMParser();


//         const html =
//           parser.parseFromString(
//             data.sections[
//               'cart-icon-bubble'
//             ],
//             'text/html'
//           );


//         const newCartIcon =
//           html.querySelector(
//             '#cart-icon-bubble'
//           );


//         const currentCartIcon =
//           document.querySelector(
//             '#cart-icon-bubble'
//           );


//         if (
//           newCartIcon &&
//           currentCartIcon
//         ) {

//           currentCartIcon.replaceWith(
//             newCartIcon
//           );


//           console.log(
//             'Cart icon updated using fallback.'
//           );


//           return true;

//         }

//       } catch (error) {

//         console.error(
//           'Cart icon update error:',
//           error
//         );

//       }

//     }


//     return false;

//   }


//   /*
//    * =========================================================
//    * ADD CUSTOM PACK
//    * =========================================================
//    */

//   addButton.addEventListener(
//     'click',
//     async function () {

//       hideError();


//       /*
//        * -------------------------------------------------------
//        * GET PACK SIZE
//        * -------------------------------------------------------
//        */

//       const selectedPack =
//         document.querySelector(
//           'input[name="custom_pack_size"]:checked'
//         );


//       if (!selectedPack) {

//         showError(
//           'Please select a pack size.'
//         );

//         return;

//       }


//       const packSize =
//         selectedPack.value;


//       /*
//        * -------------------------------------------------------
//        * GET FLAVORS
//        * -------------------------------------------------------
//        */

//       const flavors =
//         getSelectedFlavors();


//       console.log(
//         'Selected Pack:',
//         packSize
//       );


//       console.log(
//         'All Flavor Selections:',
//         flavors
//       );


//       /*
//        * -------------------------------------------------------
//        * REMOVE EMPTY FLAVORS
//        * -------------------------------------------------------
//        */

//       const selectedFlavors =
//         flavors.filter(
//           function (flavor) {

//             return (
//               flavor &&
//               flavor.trim() !== ''
//             );

//           }
//         );


//       console.log(
//         'Selected Flavors:',
//         selectedFlavors
//       );


//       /*
//        * -------------------------------------------------------
//        * MINIMUM 2 FLAVORS
//        * -------------------------------------------------------
//        */

//       if (
//         selectedFlavors.length < 2
//       ) {

//         showError(
//           'Please select at least 2 flavors.'
//         );

//         return;

//       }


//       /*
//        * -------------------------------------------------------
//        * MAXIMUM 3 FLAVORS
//        * -------------------------------------------------------
//        */

//       if (
//         selectedFlavors.length > 3
//       ) {

//         showError(
//           'You can select a maximum of 3 flavors.'
//         );

//         return;

//       }


//       /*
//        * -------------------------------------------------------
//        * DUPLICATE FLAVOR VALIDATION
//        * -------------------------------------------------------
//        */

//       if (
//         hasDuplicateFlavors(
//           selectedFlavors
//         )
//       ) {

//         showError(
//           'Please select different flavors.'
//         );

//         /*
//          * Refresh options
//          */

//         updateFlavorOptions();

//         return;

//       }


//       /*
//        * =====================================================
//        * GENERATE UNIQUE CUSTOM PACK ID
//        * =====================================================
//        */

//       const customPackId =
//         generateCustomPackId();


//       /*
//        * =====================================================
//        * DETERMINE DISCOUNT RATE
//        * =====================================================
//        *
//        * 2 flavors = 10%
//        * 3 flavors = 15%
//        */

//       let discountRate = 0;


//       if (
//         selectedFlavors.length === 2
//       ) {

//         discountRate = 10;

//       }


//       if (
//         selectedFlavors.length === 3
//       ) {

//         discountRate = 15;

//       }


//       console.log(
//         'Custom Pack ID:',
//         customPackId
//       );


//       console.log(
//         'Custom Pack Flavor Count:',
//         selectedFlavors.length
//       );


//       console.log(
//         'Expected Discount:',
//         discountRate + '%'
//       );


//       /*
//        * =====================================================
//        * BUILD CART ITEMS
//        * =====================================================
//        */

//       const items = [];


//       selectedFlavors.forEach(
//         function (flavor) {

//           const variantId =
//             getVariantId(
//               flavor,
//               packSize
//             );


//           console.log(
//             'Flavor:',
//             flavor,
//             'Pack:',
//             packSize,
//             'Variant:',
//             variantId
//           );


//           if (variantId) {

//             items.push({

//               id:
//                 Number(
//                   variantId
//                 ),

//               quantity:
//                 1,


//               /*
//                * =================================================
//                * CUSTOM PACK PROPERTIES
//                * =================================================
//                */

//               properties: {

//                 /*
//                  * Main identifier
//                  */

//                 "_custom_pack":
//                   "true",


//                 /*
//                  * Unique custom pack ID
//                  */

//                 "_custom_pack_id":
//                   customPackId,


//                 /*
//                  * Number of selected flavors
//                  */

//                 "_custom_pack_flavors":
//                   String(
//                     selectedFlavors.length
//                   ),


//                 /*
//                  * Pack size
//                  */

//                 "_custom_pack_size":
//                   String(
//                     packSize
//                   ),


//                 /*
//                  * Discount percentage
//                  *
//                  * This value is currently
//                  * kept as requested.
//                  */

//                 "_custom_pack_discount":
//                   String(
//                     discountRate
//                   ) + '%'

//               }

//             });

//           }

//         }
//       );


//       /*
//        * =====================================================
//        * VALIDATE CART ITEMS
//        * =====================================================
//        */

//       if (
//         items.length !==
//         selectedFlavors.length
//       ) {

//         console.error(
//           'Unable to create all cart items.',
//           {
//             flavors:
//               selectedFlavors,

//             items:
//               items
//           }
//         );


//         showError(
//           'One or more selected flavors could not be found.'
//         );

//         return;

//       }


//       /*
//        * =====================================================
//        * BUTTON LOADING
//        * =====================================================
//        */

//       const originalText =
//         addButton.textContent;


//       addButton.disabled =
//         true;


//       addButton.textContent =
//         'Adding...';


//       try {


//         /*
//          * =====================================================
//          * ADD PRODUCTS TO SHOPIFY CART
//          * =====================================================
//          */

//         const response =
//           await fetch(
//             window.Shopify.routes.root +
//             'cart/add.js',
//             {

//               method: 'POST',

//               headers: {

//                 'Content-Type':
//                   'application/json',

//                 'Accept':
//                   'application/json'

//               },

//               body:
//                 JSON.stringify({

//                   items:
//                     items,


//                   /*
//                    * Request fresh cart sections
//                    */

//                   sections: [

//                     'cart-drawer',

//                     'cart-icon-bubble'

//                   ],


//                   sections_url:
//                     window.location.pathname

//                 })

//             }
//           );


//         /*
//          * =====================================================
//          * PARSE RESPONSE
//          * =====================================================
//          */

//         const data =
//           await response.json();


//         console.log(
//           'Shopify Cart Response:',
//           data
//         );


//         /*
//          * =====================================================
//          * CHECK SHOPIFY ERROR
//          * =====================================================
//          */

//         if (!response.ok) {

//           throw new Error(
//             data.description ||
//             data.message ||
//             'Unable to add customized pack.'
//           );

//         }


//         /*
//          * =====================================================
//          * UPDATE CART DRAWER
//          * =====================================================
//          */

//         updateCartDrawer(
//           data
//         );


//         /*
//          * =====================================================
//          * CLOSE CUSTOMIZATION MODAL
//          * =====================================================
//          */

//         closeModal();


//         /*
//          * =====================================================
//          * FALLBACK OPEN CART DRAWER
//          * =====================================================
//          */

//         setTimeout(
//           function () {

//             const cartDrawer =
//               document.querySelector(
//                 'cart-drawer'
//               );


//             if (
//               cartDrawer &&
//               !cartDrawer.classList.contains(
//                 'active'
//               ) &&
//               typeof cartDrawer.open ===
//                 'function'
//             ) {

//               cartDrawer.open();

//             }

//           },
//           100
//         );


//       } catch (error) {

//         console.error(
//           'CUSTOM PACK ERROR:',
//           error
//         );


//         showError(
//           error.message ||
//           'Something went wrong. Please try again.'
//         );


//       } finally {


//         /*
//          * =====================================================
//          * RESTORE BUTTON
//          * =====================================================
//          */

//         addButton.disabled =
//           false;


//         addButton.textContent =
//           originalText;

//       }

//     }
//   );

// });




document.addEventListener('DOMContentLoaded', function () {

  /*
   * =========================================================
   * ELEMENTS
   * =========================================================
   */

  const trigger =
    document.getElementById('CustomizePackTrigger');

  const modal =
    document.getElementById('CustomizePackModal');

  const closeButton =
    document.getElementById('CustomizePackClose');

  const overlay =
    modal
      ? modal.querySelector('.customize-pack-overlay')
      : null;

  const flavorRow3 =
    document.getElementById('CustomFlavorRow3');

  const addButton =
    document.getElementById('CustomPackAddToCart');

  const errorMessage =
    document.getElementById('CustomPackError');

  const packSizeInputs =
    document.querySelectorAll(
      'input[name="custom_pack_size"]'
    );


  /*
   * =========================================================
   * REQUIRED ELEMENT CHECK
   * =========================================================
   */

  if (!trigger || !modal || !addButton) {

    console.log(
      'Customize Pack: Required elements not found.'
    );

    return;
  }


  /*
   * =========================================================
   * FLAVOR VARIANT IDs
   * =========================================================
   *
   * 2 = 2 Packs
   * 3 = 3 Packs
   */

  const flavorVariants = {

    berry: {
      2: 52068743446803,
      3: 52068742070547
    },

    sweetPotato: {
      2: 52124354511123,
      3: 52124354543891
    },

    southernOriginal: {
      2: 52124358017299,
      3: 52124358050067
    }

  };


  /*
   * =========================================================
   * GENERATE UNIQUE CUSTOM PACK ID
   * =========================================================
   */

  function generateCustomPackId() {

    const timestamp =
      Date.now();

    const random =
      Math.random()
        .toString(36)
        .substring(2, 7);

    return (
      'CP-' +
      timestamp +
      '-' +
      random
    );

  }


  /*
   * =========================================================
   * OPEN MODAL
   * =========================================================
   */

  trigger.addEventListener(
    'click',
    function () {

      modal.hidden = false;

      document.body.classList.add(
        'customize-pack-open'
      );

      /*
       * Update selector state when modal opens
       */

      updateFlavorSelectorState();

    }
  );


  /*
   * =========================================================
   * CLOSE MODAL
   * =========================================================
   */

  function closeModal() {

    modal.hidden = true;

    document.body.classList.remove(
      'customize-pack-open'
    );

  }


  if (closeButton) {

    closeButton.addEventListener(
      'click',
      closeModal
    );

  }


  if (overlay) {

    overlay.addEventListener(
      'click',
      closeModal
    );

  }


  /*
   * =========================================================
   * ESCAPE KEY
   * =========================================================
   */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        !modal.hidden
      ) {

        closeModal();

      }

    }
  );


  /*
   * =========================================================
   * ERROR FUNCTIONS
   * =========================================================
   */

  function showError(message) {

    if (!errorMessage) {
      return;
    }

    errorMessage.textContent =
      message;

    errorMessage.hidden = false;

  }


  function hideError() {

    if (!errorMessage) {
      return;
    }

    errorMessage.textContent = '';

    errorMessage.hidden = true;

  }


  /*
   * =========================================================
   * GET SELECTED PACK SIZE
   * =========================================================
   */

  function getPackSize() {

    const selectedPack =
      document.querySelector(
        'input[name="custom_pack_size"]:checked'
      );

    if (!selectedPack) {
      return null;
    }

    return String(
      selectedPack.value
    );

  }


  /*
   * =========================================================
   * PACK SIZE SELECTION
   * =========================================================
   *
   * 2 Packs = 2 flavor selectors
   * 3 Packs = 3 flavor selectors
   */

  packSizeInputs.forEach(
    function (input) {

      input.addEventListener(
        'change',
        function () {

          hideError();


          /*
           * Remove active class
           */

          document
            .querySelectorAll(
              '.custom-pack-size-option'
            )
            .forEach(
              function (option) {

                option.classList.remove(
                  'active'
                );

              }
            );


          /*
           * Add active class
           */

          const parent =
            input.closest(
              '.custom-pack-size-option'
            );


          if (parent) {

            parent.classList.add(
              'active'
            );

          }


          /*
           * =================================================
           * 2 PACKS
           * =================================================
           *
           * Only 2 flavor selectors.
           */

          if (
            String(input.value) === '2'
          ) {

            if (flavorRow3) {

              flavorRow3.hidden = true;

            }


            /*
             * Clear third flavor
             */

            const flavor3 =
              document.getElementById(
                'custom-flavor-3'
              );


            if (flavor3) {

              flavor3.value = '';

              /*
               * Trigger change event
               * if custom dropdown uses change listener.
               */

              flavor3.dispatchEvent(
                new Event(
                  'change',
                  {
                    bubbles: true
                  }
                )
              );

            }

          }


          /*
           * =================================================
           * 3 PACKS
           * =================================================
           *
           * Show third flavor selector.
           */

          if (
            String(input.value) === '3'
          ) {

            if (flavorRow3) {

              flavorRow3.hidden = false;

            }

          }


          /*
           * Update duplicate flavor options
           */

          updateFlavorSelectorState();

        }
      );

    }
  );


  /*
   * =========================================================
   * INITIAL THIRD FLAVOR VISIBILITY
   * =========================================================
   */

  function updateFlavorRowVisibility() {

    const packSize =
      getPackSize();


    if (!flavorRow3) {
      return;
    }


    /*
     * 3 Packs = show third selector
     */

    if (packSize === '3') {

      flavorRow3.hidden = false;

      return;

    }


    /*
     * 2 Packs = hide third selector
     */

    flavorRow3.hidden = true;

  }


  /*
   * =========================================================
   * GET VARIANT ID
   * =========================================================
   */

  function getVariantId(
    flavor,
    packSize
  ) {

    /*
     * BERRY
     */

    if (
      flavor === 'berry' ||
      flavor === 'berry-cinnamon-roll' ||
      flavor === 'berry-cinnamon'
    ) {

      return flavorVariants
        .berry[packSize];

    }


    /*
     * SWEET POTATO
     */

    if (
      flavor === 'sweet-potato' ||
      flavor === 'sweet-potato-roll' ||
      flavor === 'sweet_potato'
    ) {

      return flavorVariants
        .sweetPotato[packSize];

    }


    /*
     * SOUTHERN ORIGINAL
     */

    if (
      flavor === 'southern-original' ||
      flavor === 'southern-original-roll' ||
      flavor === 'southern_original'
    ) {

      return flavorVariants
        .southernOriginal[packSize];

    }


    /*
     * UNKNOWN FLAVOR
     */

    return null;

  }


  /*
   * =========================================================
   * GET SELECTED FLAVORS
   * =========================================================
   */

  function getSelectedFlavors() {

    const flavor1 =
      document.getElementById(
        'custom-flavor-1'
      )?.value || '';


    const flavor2 =
      document.getElementById(
        'custom-flavor-2'
      )?.value || '';


    const flavor3 =
      document.getElementById(
        'custom-flavor-3'
      )?.value || '';


    const packSize =
      getPackSize();


    /*
     * 2 Packs
     *
     * Only first 2 selectors are considered.
     */

    if (packSize === '2') {

      return [
        flavor1,
        flavor2
      ];

    }


    /*
     * 3 Packs
     *
     * All 3 selectors are considered.
     */

    return [
      flavor1,
      flavor2,
      flavor3
    ];

  }


  /*
   * =========================================================
   * NORMALIZE FLAVOR
   * =========================================================
   *
   * Used for duplicate checking.
   */

  function normalizeFlavor(flavor) {

    return String(flavor || '')
      .trim()
      .toLowerCase();

  }


  /*
   * =========================================================
   * DUPLICATE FLAVOR PREVENTION
   * =========================================================
   *
   * Prevent the same flavor from being selected
   * in multiple selectors.
   */

  function updateFlavorSelectorState() {

    const selectorIds = [
      'custom-flavor-1',
      'custom-flavor-2',
      'custom-flavor-3'
    ];


    const selectors =
      selectorIds
        .map(
          function (id) {

            return document.getElementById(id);

          }
        )
        .filter(
          function (select) {

            return !!select;

          }
        );


    /*
     * Current selected values
     */

    const selectedValues = [];


    selectors.forEach(
      function (select) {

        const value =
          normalizeFlavor(
            select.value
          );


        if (value) {

          selectedValues.push(value);

        }

      }
    );


    /*
     * Update options
     */

    selectors.forEach(
      function (select) {

        const currentValue =
          normalizeFlavor(
            select.value
          );


        Array.from(
          select.options
        ).forEach(
          function (option) {

            const optionValue =
              normalizeFlavor(
                option.value
              );


            /*
             * Keep placeholder enabled.
             */

            if (!optionValue) {

              option.disabled = false;

              return;

            }


            /*
             * If another selector already uses
             * this flavor, disable it.
             */

            const usedElsewhere =
              selectedValues.includes(
                optionValue
              ) &&
              optionValue !== currentValue;


            option.disabled =
              usedElsewhere;

          }
        );

      }
    );

  }


  /*
   * =========================================================
   * FLAVOR CHANGE EVENTS
   * =========================================================
   */

  [
    'custom-flavor-1',
    'custom-flavor-2',
    'custom-flavor-3'
  ].forEach(
    function (id) {

      const select =
        document.getElementById(id);


      if (!select) {
        return;
      }


      select.addEventListener(
        'change',
        function () {

          hideError();

          updateFlavorSelectorState();

        }
      );

    }
  );


  /*
   * =========================================================
   * UPDATE CART DRAWER
   * =========================================================
   */

  function updateCartDrawer(data) {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    /*
     * =======================================================
     * NATIVE DAWN CART DRAWER
     * =======================================================
     */

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents ===
        'function'
    ) {

      try {

        cartDrawer.renderContents(
          data
        );


        console.log(
          'Cart drawer updated using renderContents().'
        );


        return true;

      } catch (error) {

        console.error(
          'CartDrawer renderContents error:',
          error
        );

      }

    }


    /*
     * =======================================================
     * FALLBACK CART ICON
     * =======================================================
     */

    if (
      data.sections &&
      data.sections[
        'cart-icon-bubble'
      ]
    ) {

      try {

        const parser =
          new DOMParser();


        const html =
          parser.parseFromString(
            data.sections[
              'cart-icon-bubble'
            ],
            'text/html'
          );


        const newCartIcon =
          html.querySelector(
            '#cart-icon-bubble'
          );


        const currentCartIcon =
          document.querySelector(
            '#cart-icon-bubble'
          );


        if (
          newCartIcon &&
          currentCartIcon
        ) {

          currentCartIcon.replaceWith(
            newCartIcon
          );


          console.log(
            'Cart icon updated using fallback.'
          );


          return true;

        }

      } catch (error) {

        console.error(
          'Cart icon update error:',
          error
        );

      }

    }


    return false;

  }


  /*
   * =========================================================
   * ADD CUSTOM PACK
   * =========================================================
   */

  addButton.addEventListener(
    'click',
    async function () {

      hideError();


      /*
       * =======================================================
       * GET PACK SIZE
       * =======================================================
       */

      const selectedPack =
        document.querySelector(
          'input[name="custom_pack_size"]:checked'
        );


      if (!selectedPack) {

        showError(
          'Please select a pack size.'
        );

        return;

      }


      const packSize =
        String(
          selectedPack.value
        );


      /*
       * =======================================================
       * GET FLAVORS
       * =======================================================
       */

      const flavors =
        getSelectedFlavors();


      console.log(
        'Selected Pack:',
        packSize
      );


      console.log(
        'All Flavor Selections:',
        flavors
      );


      /*
       * =======================================================
       * REMOVE EMPTY VALUES
       * =======================================================
       */

      const selectedFlavors =
        flavors.filter(
          function (flavor) {

            return (
              flavor &&
              flavor.trim() !== ''
            );

          }
        );


      console.log(
        'Selected Flavors:',
        selectedFlavors
      );


      /*
       * =======================================================
       * VALIDATE NUMBER OF FLAVORS
       * =======================================================
       *
       * 2 Packs:
       * exactly 2 flavors.
       *
       * 3 Packs:
       * minimum 2 and maximum 3 flavors.
       */

      if (packSize === '2') {

        if (
          selectedFlavors.length !== 2
        ) {

          showError(
            'Please select 2 flavors.'
          );

          return;

        }

      }


      if (packSize === '3') {

        if (
          selectedFlavors.length < 2
        ) {

          showError(
            'Please select at least 2 flavors.'
          );

          return;

        }


        if (
          selectedFlavors.length > 3
        ) {

          showError(
            'You can select a maximum of 3 flavors.'
          );

          return;

        }

      }


      /*
       * =======================================================
       * CHECK DUPLICATE FLAVORS
       * =======================================================
       */

      const normalizedFlavors =
        selectedFlavors.map(
          function (flavor) {

            return normalizeFlavor(
              flavor
            );

          }
        );


      const uniqueFlavors =
        new Set(
          normalizedFlavors
        );


      if (
        uniqueFlavors.size !==
        normalizedFlavors.length
      ) {

        showError(
          'Please select different flavors. The same flavor cannot be selected twice.'
        );

        return;

      }


      /*
       * =======================================================
       * GENERATE CUSTOM PACK ID
       * =======================================================
       */

      const customPackId =
        generateCustomPackId();


      /*
       * =======================================================
       * DETERMINE DISCOUNT
       * =======================================================
       *
       * 2 flavors = 10%
       * 3 flavors = 15%
       */

      let discountRate = 0;


      if (
        selectedFlavors.length === 2
      ) {

        discountRate = 10;

      }


      if (
        selectedFlavors.length === 3
      ) {

        discountRate = 15;

      }


      console.log(
        'Custom Pack ID:',
        customPackId
      );


      console.log(
        'Custom Pack Flavor Count:',
        selectedFlavors.length
      );


      console.log(
        'Expected Discount:',
        discountRate + '%'
      );


      /*
       * =======================================================
       * BUILD CART ITEMS
       * =======================================================
       */

      const items = [];


      selectedFlavors.forEach(
        function (flavor) {

          const variantId =
            getVariantId(
              flavor,
              packSize
            );


          console.log(
            'Flavor:',
            flavor,
            'Pack:',
            packSize,
            'Variant:',
            variantId
          );


          if (variantId) {

            items.push({

              /*
               * Shopify Variant ID
               */

              id:
                Number(
                  variantId
                ),


              /*
               * One quantity per selected flavor
               */

              quantity: 1,


              /*
               * Custom Pack Properties
               */

              properties: {

                /*
                 * Main custom pack identifier
                 */

                "_custom_pack":
                  "true",


                /*
                 * Unique ID for this pack
                 */

                "_custom_pack_id":
                  customPackId,


                /*
                 * Number of selected flavors
                 */

                "_custom_pack_flavors":
                  String(
                    selectedFlavors.length
                  ),


                /*
                 * Pack size
                 */

                "_custom_pack_size":
                  String(
                    packSize
                  ),


                /*
                 * Discount percentage
                 */

                "_custom_pack_discount":
                  String(
                    discountRate
                  ) + '%'

              }

            });

          }

        }
      );


      /*
       * =======================================================
       * VALIDATE CART ITEMS
       * =======================================================
       */

      if (
        items.length !==
        selectedFlavors.length
      ) {

        console.error(
          'Unable to create all cart items.',
          {
            flavors:
              selectedFlavors,

            items:
              items
          }
        );


        showError(
          'One or more selected flavors could not be found.'
        );

        return;

      }


      /*
       * =======================================================
       * BUTTON LOADING
       * =======================================================
       */

      const originalText =
        addButton.textContent;


      addButton.disabled =
        true;


      addButton.textContent =
        'Adding...';


      try {

        /*
         * =====================================================
         * ADD TO SHOPIFY CART
         * =====================================================
         */

        const response =
          await fetch(
            window.Shopify.routes.root +
            'cart/add.js',
            {

              method: 'POST',

              headers: {

                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'

              },

              body:
                JSON.stringify({

                  items:
                    items,

                  /*
                   * Request fresh cart sections
                   */

                  sections: [
                    'cart-drawer',
                    'cart-icon-bubble'
                  ],

                  sections_url:
                    window.location.pathname

                })

            }
          );


        /*
         * =====================================================
         * PARSE RESPONSE
         * =====================================================
         */

        const data =
          await response.json();


        console.log(
          'Shopify Cart Response:',
          data
        );


        /*
         * =====================================================
         * CHECK SHOPIFY ERROR
         * =====================================================
         */

        if (!response.ok) {

          throw new Error(
            data.description ||
            data.message ||
            'Unable to add customized pack.'
          );

        }


        /*
         * =====================================================
         * UPDATE CART DRAWER
         * =====================================================
         */

        updateCartDrawer(
          data
        );


        /*
         * =====================================================
         * CLOSE MODAL
         * =====================================================
         */

        closeModal();


        /*
         * =====================================================
         * OPEN CART DRAWER
         * =====================================================
         */

        setTimeout(
          function () {

            const cartDrawer =
              document.querySelector(
                'cart-drawer'
              );


            if (
              cartDrawer &&
              !cartDrawer.classList.contains(
                'active'
              ) &&
              typeof cartDrawer.open ===
                'function'
            ) {

              cartDrawer.open();

            }

          },
          100
        );


      } catch (error) {

        console.error(
          'CUSTOM PACK ERROR:',
          error
        );


        showError(
          error.message ||
          'Something went wrong. Please try again.'
        );


      } finally {

        /*
         * =====================================================
         * RESTORE BUTTON
         * =====================================================
         */

        addButton.disabled =
          false;


        addButton.textContent =
          originalText;

      }

    }
  );


  /*
   * =========================================================
   * INITIAL SETUP
   * =========================================================
   */

  updateFlavorRowVisibility();

  updateFlavorSelectorState();


  /*
   * Set active pack option on page load
   */

  const initialPack =
    document.querySelector(
      'input[name="custom_pack_size"]:checked'
    );


  if (initialPack) {

    const initialParent =
      initialPack.closest(
        '.custom-pack-size-option'
      );


    if (initialParent) {

      initialParent.classList.add(
        'active'
      );

    }

  }


  console.log(
    'Customize Pack JS initialized successfully.'
  );

});